module.exports = __webpack_public_path__ + "public/img/home_main2_btnr@1x.6d3b4f48.png";